<div class="h-100 single-report-page">
    <app-admin-report [columns]="cityToReport" [hasFilters]="true"
                      [apiUrl]="cityToReportAPI" [isExportToExcel]="true"
                      reportTitle="ADMINISTRATION.CITY_TO_UNDELIVERED_COD_SUM" [filterCustomer]="true"
                      [statics]="cityToStatistics" [queryParams]="{'isDelivered':isDelivered}">
    </app-admin-report>
</div>